var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('v-btn',{style:(`z-index: 2; background-color: ${_vm.mainColor}`),attrs:{"absolute":"","width":_vm.width,"height":_vm.height,"dark":""}},[_c('span',{staticClass:"font-weight-bold text-capitalize font-14"},[_vm._v(_vm._s(_vm.badgeText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }